(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bundle-serum-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bundle-serum-selector')) {
    customElements.define('bundle-serum-selector', class extends HTMLElement {
      connectedCallback() {
        this.onchange = (event) => {
          if (!(event.target instanceof HTMLSelectElement)) return;
          const destination = new URL(event.target.value, window.location.origin);
          const previewTheme = new URL(window.location.href).searchParams.get('preview_theme_id');
          if (previewTheme) destination.searchParams.set('preview_theme_id', previewTheme);
          window.location.assign(destination.href);
        };
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["international-shipping-note"] && !Shopify.designMode) return;
  try {
    (() => {
    let countryRequest;

    function detectedCountry() {
      if (!countryRequest) {
        countryRequest = (async () => {
          const controller = new AbortController();
          const timeout = setTimeout(() => controller.abort(), 5000);
          try {
            const root = window.Shopify?.routes?.root || '/';
            const response = await fetch(`${root}browsing_context_suggestions.json?country[enabled]=true`, {
              signal: controller.signal,
              credentials: 'same-origin'
            });
            if (!response.ok) return null;
            const data = await response.json();
            const country = data?.detected_values?.country?.handle;
            return typeof country === 'string' && /^[A-Z]{2}$/.test(country) ? country : null;
          } catch {
            return null;
          } finally {
            clearTimeout(timeout);
          }
        })();
      }
      return countryRequest;
    }

    async function updateNotes() {
      const notes = document.querySelectorAll('[data-international-shipping-note]');
      if (!notes.length) return;

      // Override only this message; country, pricing, and shipping rates are unchanged.
      const preview = new URLSearchParams(window.location.search).get('international_shipping_preview');
      if (preview === '1' || preview === '0') {
        notes.forEach((note) => { note.hidden = preview !== '1'; });
        return;
      }

      const country = await detectedCountry();
      notes.forEach((note) => {
        note.hidden = !country || country === 'US';
      });
    }

    updateNotes();
    document.addEventListener('shopify:section:load', updateNotes);
  })();
  } catch(e) { console.error(e); }
})();

})();
